export const getUserId = () => {
    const userId = localStorage.getItem("user_id");
    return userId ? Number(userId) : null;
  };